// @core/api/endpoints/booking/update_booking_type.ts
// Auto-generated by corebuilder. DO NOT EDIT.

import { getApiClient, type RequestOptions } from '../../client';
import type {
  BookingTypeDefinitionResponse,
  UpdateBookingTypeRequest,
} from '../../../types/booking';

const BASE_PATH = '/booking';

/**
 * Update booking type
 * Updates a booking type definition (pricing defaults, duration, cancellation rules, capacity, Kafka topics).
 */
export async function UpdateBookingType(
  type_id: string,
  data: UpdateBookingTypeRequest,
  options?: RequestOptions
): Promise<BookingTypeDefinitionResponse> {
  const client = getApiClient();
  let requestPath = `${BASE_PATH}/booking-types/:type_id`;
  requestPath = requestPath.replace(':type_id', encodeURIComponent(type_id));
  const requestOptions = options;
  return client.put<BookingTypeDefinitionResponse>(requestPath, data, requestOptions);
}
